"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.Column = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject, _templateObject2;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  height: calc(100% - 36px);\n  overflow: auto;\n  min-width: fit-content;\n\n  .row-container {\n    display: flex;\n    cursor: pointer;\n    align-items: center;\n    &:hover {\n      background-color: #fafafa;\n    }\n\n    .chk-container {\n      width: 30px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      .chk-item {\n        width: 16px;\n        height: 16px;\n      }\n    }\n  }\n"])));

exports.Container = Container;

var Column = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  flex: ", ";\n  min-width: ", "px;\n  text-align: center;\n  color: #262626;\n  font-family: ", ";\n  font-size: 12px;\n  line-height: 16px;\n  padding: 10px 5px;\n  display: flex;\n  justify-content: center;\n"])), function (_ref) {
  var flex = _ref.flex;
  return flex ? flex : 1;
}, function (_ref2) {
  var minWidth = _ref2.minWidth;
  return minWidth ? minWidth : 100;
}, _variables.FontFamily.Lato);

exports.Column = Column;